import { Component, OnInit } from '@angular/core';
import { AuthService } from '@fo-angular/fire';
// import { AuthService } from 'src/app/modules/fire/services/fire.service';
import { app } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {

  press: any;
  ctrl;

  title: string = app.name;

  reg: boolean = false;

  e: string; p: string;
  
  constructor(
  private auth: AuthService
  ) { 
		this.press = new Audio();
		// this.press.src = '../../assets/audio/button.mp3';
        this.press.load();
		this.press.playbackRate=2.1;
  }

  ngOnInit() {}

  switch(e) {
      const t = e.target||e.details||e;
      const v = t.value||t.details||t;
      this.reg = (v)?!this.reg:this.reg;
  }










  async loginWith(provider) {
    const u: any = await this.auth.login(provider);
    if(u)
    this.ctrl.dismiss((u.uid)?u:u.user);
  }










  async loginWithEP() {
    const u: any = await this.auth.emailPass(this.e, this.p);
    if(u)
    this.ctrl.dismiss((u.uid)?u:u.user);
  }










  async registerWithEP() {
    const u: any = await this.auth.register(this.e, this.p);
    if(u)
    this.ctrl.dismiss((u.uid)?u:u.user);
  }










}
